module.exports = __webpack_public_path__ + "static/media/takeawalk.134c0d94.jpg";